import { log } from "../utils/logger";

interface SampleOptions {
  SAMPLE_COUNT?: number;
}

interface StatusOptions {
  [key: string]: string;
}

interface Record {
  id: number;
  name: string;
  status: string;
  created_at: Date;
}

export default function generateSamples({ SAMPLE_COUNT = 100 }: SampleOptions = {}) {
  log(`%c[+] Generating [${SAMPLE_COUNT}] mock[SAMPLES]`, "color:green");

  // Exported Array
  const SAMPLE_DATA: Record[] = [];

  // Generator configs
  // 0=editing, 1=scheduled, 2=launched, 3=completed, -1=paused, 4=waiting for approval
  const SAMPLE_STATUSES: StatusOptions = {
    "-2": "error",
    "-1": "paused",
    "1": "scheduled",
    "0": "editing",
    "2": "launched",
    "3": "completed",
    "4": "waiting",
  };

  for (let i = 0; i < SAMPLE_COUNT; i++) {
    const status_int = Math.round(Math.random() * (Object.keys(SAMPLE_STATUSES).length - 1) - 2);
    const status_vch = SAMPLE_STATUSES[status_int];

    const sample_record: Record = {
      id: i,
      name: `Sample ${i}`,
      status: status_vch,
      created_at: new Date(),
    };

    SAMPLE_DATA.push(sample_record);
  }

  return SAMPLE_DATA;
}
